const initialState = {};

export default function loading(state = initialState, action) {
  const { type } = action;
  const matches = /^FETCH_(.*)_(REQUEST|SUCCESS|FAIL)$/.exec(type);

  if (!matches) return state;

  const [, requestName, requestState] = matches;
  return {
    ...state,
    [requestName.toLowerCase()]: {
      loading: requestState === "REQUEST",
      error: requestState === "FAIL",
    },
  };
}
